var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"targetEl",style:(`min-height:${_vm.fixedMinHeight ? _vm.fixedMinHeight : _vm.minHeight}px`)},[(_vm.shouldRender)?_vm._t("default"):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }